/**
 * Created by fworld on 2019/10/9.
 */
import request from '@/util/request'

export const screenSaverCreate = (data) => {
    return request({
        'url': '/api/v1/delivery/screenSaver/create',
        'method': 'post',
        data
    })
}

export const screenSaverUpdate = (data) => {
    return request({
        'url': '/api/v1/delivery/screenSaver/update',
        'method': 'post',
        data
    })
}

export const screenSaverList = () => {
    return request({
        'url': '/api/v1/delivery/screenSaver/list',
        'method': 'get',
    })
}

export const screenSaverDeviceUnion = (params) => {
    return request({
        'url': '/api/v1/delivery/screenSaver/device/union',
        'method': 'get',
        params
    })
}

export const screenSaverDeviceList = (params) => {
    return request({
        'url': '/api/v1/delivery/screenSaver/device/list',
        'method': 'get',
        params
    })
}

export const screenSaverDeviceBind = (data) => {
    return request({
        'url': '/api/v1/delivery/screenSaver/device/bind',
        'method': 'post',
        data
    })
}

export const screenSaverDeviceUnBind = (params) => {
    return request({
        'url': '/api/v1/delivery/screenSaver/device/unbind',
        'method': 'get',
        params
    })
}